// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AtmodalRouteRouteImport } from './routes/@modal/route'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as LandingRouteRouteImport } from './routes/_landing/route'
import { Route as PublicRouteRouteImport } from './routes/_public/route'
import { Route as AtmodalAssistantRouteImport } from './routes/@modal/assistant'
import { Route as AtmodalCookiesRouteImport } from './routes/@modal/cookies'
import { Route as AppAccountRouteImport } from './routes/_app/account'
import { Route as AppCheckoutRouteImport } from './routes/_app/checkout'
import { Route as AppDevResourcesRouteImport } from './routes/_app/dev-resources'
import { Route as AppEmployeesRouteImport } from './routes/_app/employees'
import { Route as AppJobsRouteImport } from './routes/_app/jobs'
import { Route as AppMarketRouteImport } from './routes/_app/market'
import { Route as AppOffersRouteImport } from './routes/_app/offers'
import { Route as AppOrgsRouteImport } from './routes/_app/orgs'
import { Route as AppReportRouteImport } from './routes/_app/report'
import { Route as AppTeamsRouteImport } from './routes/_app/teams'
import { Route as LandingCookiesPolicyRouteImport } from './routes/_landing/cookies-policy'
import { Route as LandingDocsRouteImport } from './routes/_landing/docs'
import { Route as LandingPrivacyPolicyRouteImport } from './routes/_landing/privacy-policy'
import { Route as LandingTermsOfUseRouteImport } from './routes/_landing/terms-of-use'
import { Route as PublicBeginPasswordResetRouteImport } from './routes/_public/begin-password-reset'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as AtmodalApplicantsApplicantIdRouteImport } from './routes/@modal/applicants.$applicantId'
import { Route as AtmodalEmployeesImportRouteImport } from './routes/@modal/employees.import'
import { Route as AtmodalEmployeesNewRouteImport } from './routes/@modal/employees.new'
import { Route as AtmodalGroupsNewRouteImport } from './routes/@modal/groups.new'
import { Route as AtmodalJobsFindRouteImport } from './routes/@modal/jobs.find'
import { Route as AtmodalJobsNewRouteImport } from './routes/@modal/jobs.new'
import { Route as AtmodalMembersMemberIdRouteImport } from './routes/@modal/members.$memberId'
import { Route as AtmodalOffersFindRouteImport } from './routes/@modal/offers.find'
import { Route as AtmodalOffersNewRouteImport } from './routes/@modal/offers.new'
import { Route as AtmodalOrgsNewRouteImport } from './routes/@modal/orgs.new'
import { Route as AtmodalSettingsAiAppsRouteImport } from './routes/@modal/settings.ai-apps'
import { Route as AtmodalSettingsLanguageRouteImport } from './routes/@modal/settings.language'
import { Route as AtmodalSettingsVisibilityRouteImport } from './routes/@modal/settings.visibility'
import { Route as AtmodalTeamsFindRouteImport } from './routes/@modal/teams.find'
import { Route as AtmodalTeamsNewRouteImport } from './routes/@modal/teams.new'
import { Route as AtmodalWelcomeCompanyRouteImport } from './routes/@modal/welcome.company'
import { Route as AtmodalWelcomeSamplesRouteImport } from './routes/@modal/welcome.samples'
import { Route as AppAccountIndexRouteImport } from './routes/_app/account.index'
import { Route as AppAccountApiRouteImport } from './routes/_app/account.api'
import { Route as AppAccountBillingRouteImport } from './routes/_app/account.billing'
import { Route as AppAccountIntegrationsRouteImport } from './routes/_app/account.integrations'
import { Route as AppBetaGenerateRouteImport } from './routes/_app/beta.generate'
import { Route as AppDevResourcesIndexRouteImport } from './routes/_app/dev-resources.index'
import { Route as AppDevResourcesComponentsRouteImport } from './routes/_app/dev-resources.components'
import { Route as AppDevResourcesEmailsRouteImport } from './routes/_app/dev-resources.emails'
import { Route as AppDevResourcesErrorsRouteImport } from './routes/_app/dev-resources.errors'
import { Route as AppDevResourcesTransitionsRouteImport } from './routes/_app/dev-resources.transitions'
import { Route as AppEmployeesListRouteImport } from './routes/_app/employees._list'
import { Route as AppJobsListRouteImport } from './routes/_app/jobs._list'
import { Route as AppMarketReportRouteImport } from './routes/_app/market._report'
import { Route as AppOffersListRouteImport } from './routes/_app/offers._list'
import { Route as AppOrgsIndexRouteImport } from './routes/_app/orgs.index'
import { Route as AppReportReportRouteImport } from './routes/_app/report._report'
import { Route as AppTeamsIndexRouteImport } from './routes/_app/teams.index'
import { Route as AppTeamsTeamIdRouteImport } from './routes/_app/teams.$teamId'
import { Route as AppTestIndexRouteImport } from './routes/_app/test.index'
import { Route as AppTestCompetencesRouteImport } from './routes/_app/test.competences'
import { Route as AppTestPersonalityRouteImport } from './routes/_app/test.personality'
import { Route as AppTestValuesRouteImport } from './routes/_app/test.values'
import { Route as PublicEmployeeInvitationTokenRouteImport } from './routes/_public/employee-invitation.$token'
import { Route as PublicOauthAuthorizeRouteImport } from './routes/_public/oauth.authorize'
import { Route as PublicRegisterIndexRouteImport } from './routes/_public/register.index'
import { Route as PublicRegisterApplicantRouteImport } from './routes/_public/register.applicant'
import { Route as PublicRegisterCompanyRouteImport } from './routes/_public/register.company'
import { Route as PublicUpdatePasswordTokenRouteImport } from './routes/_public/update-password.$token'
import { Route as PublicVerifyEmailTokenRouteImport } from './routes/_public/verify-email.$token'
import { Route as AtmodalApplicantsApplicantIdHireRouteImport } from './routes/@modal/applicants.$applicantId_.hire'
import { Route as AtmodalEmployeesEmployeeIdEditRouteImport } from './routes/@modal/employees.$employeeId.edit'
import { Route as AtmodalGroupsGroupIdEditRouteImport } from './routes/@modal/groups.$groupId.edit'
import { Route as AtmodalJobsJobIdEditRouteImport } from './routes/@modal/jobs.$jobId.edit'
import { Route as AtmodalOffersOfferIdEditRouteImport } from './routes/@modal/offers.$offerId.edit'
import { Route as AtmodalOffersOfferIdInviteRouteImport } from './routes/@modal/offers.$offerId.invite'
import { Route as AtmodalOrgsOrgIdEditRouteImport } from './routes/@modal/orgs.$orgId.edit'
import { Route as AtmodalOrgsGroupsFindRouteImport } from './routes/@modal/orgs.groups.find'
import { Route as AtmodalTeamsTeamIdEditRouteImport } from './routes/@modal/teams.$teamId.edit'
import { Route as AppAccountApiSplatRouteImport } from './routes/_app/account.api.$'
import { Route as AppAccountIntegrationsIndexRouteImport } from './routes/_app/account.integrations.index'
import { Route as AppAccountIntegrationsAppIdRouteImport } from './routes/_app/account.integrations.$appId'
import { Route as AppAccountIntegrationsGuideRouteImport } from './routes/_app/account.integrations.guide'
import { Route as AppDevResourcesErrorsListRouteImport } from './routes/_app/dev-resources.errors._list'
import { Route as AppDevResourcesTransitionsIndexRouteImport } from './routes/_app/dev-resources.transitions.index'
import { Route as AppDevResourcesTransitionsJobsRouteImport } from './routes/_app/dev-resources.transitions.jobs'
import { Route as AppDevResourcesTransitionsStickyRouteImport } from './routes/_app/dev-resources.transitions.sticky'
import { Route as AppDevResourcesTransitionsTeamsRouteImport } from './routes/_app/dev-resources.transitions.teams'
import { Route as AppEmployeesListIndexRouteImport } from './routes/_app/employees._list.index'
import { Route as AppEmployeesListEmployeeIdRouteImport } from './routes/_app/employees._list.$employeeId'
import { Route as AppJobsListIndexRouteImport } from './routes/_app/jobs._list.index'
import { Route as AppJobsListJobIdRouteImport } from './routes/_app/jobs._list.$jobId'
import { Route as AppMarketReportIndexRouteImport } from './routes/_app/market._report.index'
import { Route as AppOffersListIndexRouteImport } from './routes/_app/offers._list.index'
import { Route as AppOffersListOfferIdRouteImport } from './routes/_app/offers._list.$offerId'
import { Route as AppOrgsOrgIdIndexRouteImport } from './routes/_app/orgs.$orgId.index'
import { Route as AppReportReportIndexRouteImport } from './routes/_app/report._report.index'
import { Route as AppTeamsTeamIdIndexRouteImport } from './routes/_app/teams.$teamId.index'
import { Route as AppTeamsTeamIdBoardRouteImport } from './routes/_app/teams.$teamId.board'
import { Route as AppTeamsTeamIdDistributionRouteImport } from './routes/_app/teams.$teamId.distribution'
import { Route as AppTeamsTeamIdEvaluateRouteImport } from './routes/_app/teams.$teamId.evaluate'
import { Route as AppTeamsTeamIdEvaluationRouteImport } from './routes/_app/teams.$teamId.evaluation'
import { Route as AppTeamsTeamIdReportRouteImport } from './routes/_app/teams.$teamId.report'
import { Route as PublicOauthAuthorizeRequestRouteImport } from './routes/_public/oauth.authorize._request'
import { Route as AtmodalJobsJobIdDescribeChar123IndicatorChar125RouteImport } from './routes/@modal/jobs.$jobId.describe.{-$indicator}'
import { Route as AppAccountIntegrationsAppIdIndexRouteImport } from './routes/_app/account.integrations.$appId.index'
import { Route as AppAccountIntegrationsAppIdApplicantsRouteImport } from './routes/_app/account.integrations.$appId.applicants'
import { Route as AppAccountIntegrationsAppIdCompaniesRouteImport } from './routes/_app/account.integrations.$appId.companies'
import { Route as AppAccountIntegrationsAppIdJobsRouteImport } from './routes/_app/account.integrations.$appId.jobs'
import { Route as AppAccountIntegrationsAppIdPlaygroundRouteImport } from './routes/_app/account.integrations.$appId.playground'
import { Route as AppAccountIntegrationsAppIdSettingsRouteImport } from './routes/_app/account.integrations.$appId.settings'
import { Route as AppDevResourcesErrorsListIndexRouteImport } from './routes/_app/dev-resources.errors._list.index'
import { Route as AppDevResourcesTransitionsJobsIndexRouteImport } from './routes/_app/dev-resources.transitions.jobs.index'
import { Route as AppDevResourcesTransitionsJobsJobIdRouteImport } from './routes/_app/dev-resources.transitions.jobs.$jobId'
import { Route as AppEmployeesListEmployeeIdReportRouteImport } from './routes/_app/employees._list.$employeeId.report'
import { Route as AppJobsListJobIdIndexRouteImport } from './routes/_app/jobs._list.$jobId.index'
import { Route as AppJobsListJobIdBoardRouteImport } from './routes/_app/jobs._list.$jobId.board'
import { Route as AppJobsListJobIdDistributionRouteImport } from './routes/_app/jobs._list.$jobId.distribution'
import { Route as AppJobsListJobIdReportRouteImport } from './routes/_app/jobs._list.$jobId.report'
import { Route as AppOffersListOfferIdIndexRouteImport } from './routes/_app/offers._list.$offerId.index'
import { Route as AppOffersListOfferIdBoardRouteImport } from './routes/_app/offers._list.$offerId.board'
import { Route as AppOffersListOfferIdDistributionRouteImport } from './routes/_app/offers._list.$offerId.distribution'
import { Route as AppOffersListOfferIdReportRouteImport } from './routes/_app/offers._list.$offerId.report'
import { Route as AppOrgsOrgIdGroupsGroupIdRouteImport } from './routes/_app/orgs.$orgId.groups.$groupId'
import { Route as PublicOauthAuthorizeRequestIndexRouteImport } from './routes/_public/oauth.authorize._request.index'
import { Route as PublicOrgsOrgIdUsersGroupsRouteImport } from './routes/_public/orgs.$orgId.users.groups'
import { Route as AppAccountIntegrationsAppIdApplicantsListRouteImport } from './routes/_app/account.integrations.$appId.applicants._list'
import { Route as AppAccountIntegrationsAppIdCompaniesListRouteImport } from './routes/_app/account.integrations.$appId.companies._list'
import { Route as AppAccountIntegrationsAppIdJobsListRouteImport } from './routes/_app/account.integrations.$appId.jobs._list'
import { Route as AppDevResourcesTransitionsJobsJobIdIndexRouteImport } from './routes/_app/dev-resources.transitions.jobs.$jobId.index'
import { Route as AppDevResourcesTransitionsJobsJobIdBoardRouteImport } from './routes/_app/dev-resources.transitions.jobs.$jobId.board'
import { Route as AppDevResourcesTransitionsJobsJobIdDistributionRouteImport } from './routes/_app/dev-resources.transitions.jobs.$jobId.distribution'
import { Route as AppDevResourcesTransitionsJobsJobIdReportRouteImport } from './routes/_app/dev-resources.transitions.jobs.$jobId.report'
import { Route as AppOrgsOrgIdGroupsGroupIdIndexRouteImport } from './routes/_app/orgs.$orgId.groups.$groupId.index'
import { Route as AppOrgsOrgIdGroupsGroupIdBoardRouteImport } from './routes/_app/orgs.$orgId.groups.$groupId.board'
import { Route as AppOrgsOrgIdGroupsGroupIdDistributionRouteImport } from './routes/_app/orgs.$orgId.groups.$groupId.distribution'
import { Route as AppOrgsOrgIdGroupsGroupIdReportRouteImport } from './routes/_app/orgs.$orgId.groups.$groupId.report'
import { Route as PublicOrgsOrgIdUsersGroupsIndexRouteImport } from './routes/_public/orgs.$orgId.users.groups.index'
import { Route as AppAccountIntegrationsAppIdApplicantsListIndexRouteImport } from './routes/_app/account.integrations.$appId.applicants._list.index'
import { Route as AppAccountIntegrationsAppIdCompaniesListIndexRouteImport } from './routes/_app/account.integrations.$appId.companies._list.index'
import { Route as AppAccountIntegrationsAppIdJobsListIndexRouteImport } from './routes/_app/account.integrations.$appId.jobs._list.index'
import { Route as AppDevResourcesTransitionsJobsJobIdDistributionIndexRouteImport } from './routes/_app/dev-resources.transitions.jobs.$jobId.distribution.index'
import { Route as AppDevResourcesTransitionsJobsJobIdDistributionXRouteImport } from './routes/_app/dev-resources.transitions.jobs.$jobId.distribution.x'
import { Route as AppDevResourcesTransitionsJobsJobIdDistributionYRouteImport } from './routes/_app/dev-resources.transitions.jobs.$jobId.distribution.y'
import { Route as PublicOrgsOrgIdUsersGroupsGroupIdIndexRouteImport } from './routes/_public/orgs.$orgId.users.groups.$groupId.index'
import { Route as PublicOrgsOrgIdUsersGroupsGroupIdDescribeIndexRouteImport } from './routes/_public/orgs.$orgId.users.groups.$groupId.describe.index'
import { Route as PublicOrgsOrgIdUsersGroupsGroupIdDescribeIndicatorStepRouteImport } from './routes/_public/orgs.$orgId.users.groups.$groupId.describe.$indicator.$step'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AtmodalRouteRoute = AtmodalRouteRouteImport.update({
            id: '/@modal',path: '/@modal',getParentRoute: () => rootRouteImport
          })
const AppRouteRoute = AppRouteRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const LandingRouteRoute = LandingRouteRouteImport.update({
            id: '/_landing',getParentRoute: () => rootRouteImport
          })
const PublicRouteRoute = PublicRouteRouteImport.update({
            id: '/_public',getParentRoute: () => rootRouteImport
          })
const AtmodalAssistantRoute = AtmodalAssistantRouteImport.update({
            id: '/assistant',path: '/assistant',getParentRoute: () => AtmodalRouteRoute
          })
const AtmodalCookiesRoute = AtmodalCookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => AtmodalRouteRoute
          })
const AppAccountRoute = AppAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AppRouteRoute
          })
const AppCheckoutRoute = AppCheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => AppRouteRoute
          })
const AppDevResourcesRoute = AppDevResourcesRouteImport.update({
            id: '/dev-resources',path: '/dev-resources',getParentRoute: () => AppRouteRoute
          })
const AppEmployeesRoute = AppEmployeesRouteImport.update({
            id: '/employees',path: '/employees',getParentRoute: () => AppRouteRoute
          })
const AppJobsRoute = AppJobsRouteImport.update({
            id: '/jobs',path: '/jobs',getParentRoute: () => AppRouteRoute
          })
const AppMarketRoute = AppMarketRouteImport.update({
            id: '/market',path: '/market',getParentRoute: () => AppRouteRoute
          })
const AppOffersRoute = AppOffersRouteImport.update({
            id: '/offers',path: '/offers',getParentRoute: () => AppRouteRoute
          })
const AppOrgsRoute = AppOrgsRouteImport.update({
            id: '/orgs',path: '/orgs',getParentRoute: () => AppRouteRoute
          })
const AppReportRoute = AppReportRouteImport.update({
            id: '/report',path: '/report',getParentRoute: () => AppRouteRoute
          })
const AppTeamsRoute = AppTeamsRouteImport.update({
            id: '/teams',path: '/teams',getParentRoute: () => AppRouteRoute
          })
const LandingCookiesPolicyRoute = LandingCookiesPolicyRouteImport.update({
            id: '/cookies-policy',path: '/cookies-policy',getParentRoute: () => LandingRouteRoute
          })
const LandingDocsRoute = LandingDocsRouteImport.update({
            id: '/docs',path: '/docs',getParentRoute: () => LandingRouteRoute
          })
const LandingPrivacyPolicyRoute = LandingPrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => LandingRouteRoute
          })
const LandingTermsOfUseRoute = LandingTermsOfUseRouteImport.update({
            id: '/terms-of-use',path: '/terms-of-use',getParentRoute: () => LandingRouteRoute
          })
const PublicBeginPasswordResetRoute = PublicBeginPasswordResetRouteImport.update({
            id: '/begin-password-reset',path: '/begin-password-reset',getParentRoute: () => PublicRouteRoute
          })
const PublicLoginRoute = PublicLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => PublicRouteRoute
          })
const AtmodalApplicantsApplicantIdRoute = AtmodalApplicantsApplicantIdRouteImport.update({
            id: '/applicants/$applicantId',path: '/applicants/$applicantId',getParentRoute: () => AtmodalRouteRoute
          })
const AtmodalEmployeesImportRoute = AtmodalEmployeesImportRouteImport.update({
            id: '/employees/import',path: '/employees/import',getParentRoute: () => AtmodalRouteRoute
          })
const AtmodalEmployeesNewRoute = AtmodalEmployeesNewRouteImport.update({
            id: '/employees/new',path: '/employees/new',getParentRoute: () => AtmodalRouteRoute
          })
const AtmodalGroupsNewRoute = AtmodalGroupsNewRouteImport.update({
            id: '/groups/new',path: '/groups/new',getParentRoute: () => AtmodalRouteRoute
          })
const AtmodalJobsFindRoute = AtmodalJobsFindRouteImport.update({
            id: '/jobs/find',path: '/jobs/find',getParentRoute: () => AtmodalRouteRoute
          })
const AtmodalJobsNewRoute = AtmodalJobsNewRouteImport.update({
            id: '/jobs/new',path: '/jobs/new',getParentRoute: () => AtmodalRouteRoute
          })
const AtmodalMembersMemberIdRoute = AtmodalMembersMemberIdRouteImport.update({
            id: '/members/$memberId',path: '/members/$memberId',getParentRoute: () => AtmodalRouteRoute
          })
const AtmodalOffersFindRoute = AtmodalOffersFindRouteImport.update({
            id: '/offers/find',path: '/offers/find',getParentRoute: () => AtmodalRouteRoute
          })
const AtmodalOffersNewRoute = AtmodalOffersNewRouteImport.update({
            id: '/offers/new',path: '/offers/new',getParentRoute: () => AtmodalRouteRoute
          })
const AtmodalOrgsNewRoute = AtmodalOrgsNewRouteImport.update({
            id: '/orgs/new',path: '/orgs/new',getParentRoute: () => AtmodalRouteRoute
          })
const AtmodalSettingsAiAppsRoute = AtmodalSettingsAiAppsRouteImport.update({
            id: '/settings/ai-apps',path: '/settings/ai-apps',getParentRoute: () => AtmodalRouteRoute
          })
const AtmodalSettingsLanguageRoute = AtmodalSettingsLanguageRouteImport.update({
            id: '/settings/language',path: '/settings/language',getParentRoute: () => AtmodalRouteRoute
          })
const AtmodalSettingsVisibilityRoute = AtmodalSettingsVisibilityRouteImport.update({
            id: '/settings/visibility',path: '/settings/visibility',getParentRoute: () => AtmodalRouteRoute
          })
const AtmodalTeamsFindRoute = AtmodalTeamsFindRouteImport.update({
            id: '/teams/find',path: '/teams/find',getParentRoute: () => AtmodalRouteRoute
          })
const AtmodalTeamsNewRoute = AtmodalTeamsNewRouteImport.update({
            id: '/teams/new',path: '/teams/new',getParentRoute: () => AtmodalRouteRoute
          })
const AtmodalWelcomeCompanyRoute = AtmodalWelcomeCompanyRouteImport.update({
            id: '/welcome/company',path: '/welcome/company',getParentRoute: () => AtmodalRouteRoute
          })
const AtmodalWelcomeSamplesRoute = AtmodalWelcomeSamplesRouteImport.update({
            id: '/welcome/samples',path: '/welcome/samples',getParentRoute: () => AtmodalRouteRoute
          })
const AppAccountIndexRoute = AppAccountIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppAccountRoute
          })
const AppAccountApiRoute = AppAccountApiRouteImport.update({
            id: '/api',path: '/api',getParentRoute: () => AppAccountRoute
          })
const AppAccountBillingRoute = AppAccountBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AppAccountRoute
          })
const AppAccountIntegrationsRoute = AppAccountIntegrationsRouteImport.update({
            id: '/integrations',path: '/integrations',getParentRoute: () => AppAccountRoute
          })
const AppBetaGenerateRoute = AppBetaGenerateRouteImport.update({
            id: '/beta/generate',path: '/beta/generate',getParentRoute: () => AppRouteRoute
          })
const AppDevResourcesIndexRoute = AppDevResourcesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppDevResourcesRoute
          })
const AppDevResourcesComponentsRoute = AppDevResourcesComponentsRouteImport.update({
            id: '/components',path: '/components',getParentRoute: () => AppDevResourcesRoute
          })
const AppDevResourcesEmailsRoute = AppDevResourcesEmailsRouteImport.update({
            id: '/emails',path: '/emails',getParentRoute: () => AppDevResourcesRoute
          })
const AppDevResourcesErrorsRoute = AppDevResourcesErrorsRouteImport.update({
            id: '/errors',path: '/errors',getParentRoute: () => AppDevResourcesRoute
          })
const AppDevResourcesTransitionsRoute = AppDevResourcesTransitionsRouteImport.update({
            id: '/transitions',path: '/transitions',getParentRoute: () => AppDevResourcesRoute
          })
const AppEmployeesListRoute = AppEmployeesListRouteImport.update({
            id: '/_list',getParentRoute: () => AppEmployeesRoute
          })
const AppJobsListRoute = AppJobsListRouteImport.update({
            id: '/_list',getParentRoute: () => AppJobsRoute
          })
const AppMarketReportRoute = AppMarketReportRouteImport.update({
            id: '/_report',getParentRoute: () => AppMarketRoute
          })
const AppOffersListRoute = AppOffersListRouteImport.update({
            id: '/_list',getParentRoute: () => AppOffersRoute
          })
const AppOrgsIndexRoute = AppOrgsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppOrgsRoute
          })
const AppReportReportRoute = AppReportReportRouteImport.update({
            id: '/_report',getParentRoute: () => AppReportRoute
          })
const AppTeamsIndexRoute = AppTeamsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppTeamsRoute
          })
const AppTeamsTeamIdRoute = AppTeamsTeamIdRouteImport.update({
            id: '/$teamId',path: '/$teamId',getParentRoute: () => AppTeamsRoute
          })
const AppTestIndexRoute = AppTestIndexRouteImport.update({
            id: '/test/',path: '/test/',getParentRoute: () => AppRouteRoute
          })
const AppTestCompetencesRoute = AppTestCompetencesRouteImport.update({
            id: '/test/competences',path: '/test/competences',getParentRoute: () => AppRouteRoute
          })
const AppTestPersonalityRoute = AppTestPersonalityRouteImport.update({
            id: '/test/personality',path: '/test/personality',getParentRoute: () => AppRouteRoute
          })
const AppTestValuesRoute = AppTestValuesRouteImport.update({
            id: '/test/values',path: '/test/values',getParentRoute: () => AppRouteRoute
          })
const PublicEmployeeInvitationTokenRoute = PublicEmployeeInvitationTokenRouteImport.update({
            id: '/employee-invitation/$token',path: '/employee-invitation/$token',getParentRoute: () => PublicRouteRoute
          })
const PublicOauthAuthorizeRoute = PublicOauthAuthorizeRouteImport.update({
            id: '/oauth/authorize',path: '/oauth/authorize',getParentRoute: () => PublicRouteRoute
          })
const PublicRegisterIndexRoute = PublicRegisterIndexRouteImport.update({
            id: '/register/',path: '/register/',getParentRoute: () => PublicRouteRoute
          })
const PublicRegisterApplicantRoute = PublicRegisterApplicantRouteImport.update({
            id: '/register/applicant',path: '/register/applicant',getParentRoute: () => PublicRouteRoute
          })
const PublicRegisterCompanyRoute = PublicRegisterCompanyRouteImport.update({
            id: '/register/company',path: '/register/company',getParentRoute: () => PublicRouteRoute
          })
const PublicUpdatePasswordTokenRoute = PublicUpdatePasswordTokenRouteImport.update({
            id: '/update-password/$token',path: '/update-password/$token',getParentRoute: () => PublicRouteRoute
          })
const PublicVerifyEmailTokenRoute = PublicVerifyEmailTokenRouteImport.update({
            id: '/verify-email/$token',path: '/verify-email/$token',getParentRoute: () => PublicRouteRoute
          })
const AtmodalApplicantsApplicantIdHireRoute = AtmodalApplicantsApplicantIdHireRouteImport.update({
            id: '/applicants/$applicantId_/hire',path: '/applicants/$applicantId/hire',getParentRoute: () => AtmodalRouteRoute
          })
const AtmodalEmployeesEmployeeIdEditRoute = AtmodalEmployeesEmployeeIdEditRouteImport.update({
            id: '/employees/$employeeId/edit',path: '/employees/$employeeId/edit',getParentRoute: () => AtmodalRouteRoute
          })
const AtmodalGroupsGroupIdEditRoute = AtmodalGroupsGroupIdEditRouteImport.update({
            id: '/groups/$groupId/edit',path: '/groups/$groupId/edit',getParentRoute: () => AtmodalRouteRoute
          })
const AtmodalJobsJobIdEditRoute = AtmodalJobsJobIdEditRouteImport.update({
            id: '/jobs/$jobId/edit',path: '/jobs/$jobId/edit',getParentRoute: () => AtmodalRouteRoute
          })
const AtmodalOffersOfferIdEditRoute = AtmodalOffersOfferIdEditRouteImport.update({
            id: '/offers/$offerId/edit',path: '/offers/$offerId/edit',getParentRoute: () => AtmodalRouteRoute
          })
const AtmodalOffersOfferIdInviteRoute = AtmodalOffersOfferIdInviteRouteImport.update({
            id: '/offers/$offerId/invite',path: '/offers/$offerId/invite',getParentRoute: () => AtmodalRouteRoute
          })
const AtmodalOrgsOrgIdEditRoute = AtmodalOrgsOrgIdEditRouteImport.update({
            id: '/orgs/$orgId/edit',path: '/orgs/$orgId/edit',getParentRoute: () => AtmodalRouteRoute
          })
const AtmodalOrgsGroupsFindRoute = AtmodalOrgsGroupsFindRouteImport.update({
            id: '/orgs/groups/find',path: '/orgs/groups/find',getParentRoute: () => AtmodalRouteRoute
          })
const AtmodalTeamsTeamIdEditRoute = AtmodalTeamsTeamIdEditRouteImport.update({
            id: '/teams/$teamId/edit',path: '/teams/$teamId/edit',getParentRoute: () => AtmodalRouteRoute
          })
const AppAccountApiSplatRoute = AppAccountApiSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => AppAccountApiRoute
          })
const AppAccountIntegrationsIndexRoute = AppAccountIntegrationsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppAccountIntegrationsRoute
          })
const AppAccountIntegrationsAppIdRoute = AppAccountIntegrationsAppIdRouteImport.update({
            id: '/$appId',path: '/$appId',getParentRoute: () => AppAccountIntegrationsRoute
          })
const AppAccountIntegrationsGuideRoute = AppAccountIntegrationsGuideRouteImport.update({
            id: '/guide',path: '/guide',getParentRoute: () => AppAccountIntegrationsRoute
          })
const AppDevResourcesErrorsListRoute = AppDevResourcesErrorsListRouteImport.update({
            id: '/_list',getParentRoute: () => AppDevResourcesErrorsRoute
          })
const AppDevResourcesTransitionsIndexRoute = AppDevResourcesTransitionsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppDevResourcesTransitionsRoute
          })
const AppDevResourcesTransitionsJobsRoute = AppDevResourcesTransitionsJobsRouteImport.update({
            id: '/jobs',path: '/jobs',getParentRoute: () => AppDevResourcesTransitionsRoute
          })
const AppDevResourcesTransitionsStickyRoute = AppDevResourcesTransitionsStickyRouteImport.update({
            id: '/sticky',path: '/sticky',getParentRoute: () => AppDevResourcesTransitionsRoute
          })
const AppDevResourcesTransitionsTeamsRoute = AppDevResourcesTransitionsTeamsRouteImport.update({
            id: '/teams',path: '/teams',getParentRoute: () => AppDevResourcesTransitionsRoute
          })
const AppEmployeesListIndexRoute = AppEmployeesListIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppEmployeesListRoute
          })
const AppEmployeesListEmployeeIdRoute = AppEmployeesListEmployeeIdRouteImport.update({
            id: '/$employeeId',path: '/$employeeId',getParentRoute: () => AppEmployeesListRoute
          })
const AppJobsListIndexRoute = AppJobsListIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppJobsListRoute
          })
const AppJobsListJobIdRoute = AppJobsListJobIdRouteImport.update({
            id: '/$jobId',path: '/$jobId',getParentRoute: () => AppJobsListRoute
          })
const AppMarketReportIndexRoute = AppMarketReportIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppMarketReportRoute
          })
const AppOffersListIndexRoute = AppOffersListIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppOffersListRoute
          })
const AppOffersListOfferIdRoute = AppOffersListOfferIdRouteImport.update({
            id: '/$offerId',path: '/$offerId',getParentRoute: () => AppOffersListRoute
          })
const AppOrgsOrgIdIndexRoute = AppOrgsOrgIdIndexRouteImport.update({
            id: '/$orgId/',path: '/$orgId/',getParentRoute: () => AppOrgsRoute
          })
const AppReportReportIndexRoute = AppReportReportIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppReportReportRoute
          })
const AppTeamsTeamIdIndexRoute = AppTeamsTeamIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppTeamsTeamIdRoute
          })
const AppTeamsTeamIdBoardRoute = AppTeamsTeamIdBoardRouteImport.update({
            id: '/board',path: '/board',getParentRoute: () => AppTeamsTeamIdRoute
          })
const AppTeamsTeamIdDistributionRoute = AppTeamsTeamIdDistributionRouteImport.update({
            id: '/distribution',path: '/distribution',getParentRoute: () => AppTeamsTeamIdRoute
          })
const AppTeamsTeamIdEvaluateRoute = AppTeamsTeamIdEvaluateRouteImport.update({
            id: '/evaluate',path: '/evaluate',getParentRoute: () => AppTeamsTeamIdRoute
          })
const AppTeamsTeamIdEvaluationRoute = AppTeamsTeamIdEvaluationRouteImport.update({
            id: '/evaluation',path: '/evaluation',getParentRoute: () => AppTeamsTeamIdRoute
          })
const AppTeamsTeamIdReportRoute = AppTeamsTeamIdReportRouteImport.update({
            id: '/report',path: '/report',getParentRoute: () => AppTeamsTeamIdRoute
          })
const PublicOauthAuthorizeRequestRoute = PublicOauthAuthorizeRequestRouteImport.update({
            id: '/_request',getParentRoute: () => PublicOauthAuthorizeRoute
          })
const AtmodalJobsJobIdDescribeChar123IndicatorChar125Route = AtmodalJobsJobIdDescribeChar123IndicatorChar125RouteImport.update({
            id: '/jobs/$jobId/describe/{-$indicator}',path: '/jobs/$jobId/describe/{-$indicator}',getParentRoute: () => AtmodalRouteRoute
          })
const AppAccountIntegrationsAppIdIndexRoute = AppAccountIntegrationsAppIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppAccountIntegrationsAppIdRoute
          })
const AppAccountIntegrationsAppIdApplicantsRoute = AppAccountIntegrationsAppIdApplicantsRouteImport.update({
            id: '/applicants',path: '/applicants',getParentRoute: () => AppAccountIntegrationsAppIdRoute
          })
const AppAccountIntegrationsAppIdCompaniesRoute = AppAccountIntegrationsAppIdCompaniesRouteImport.update({
            id: '/companies',path: '/companies',getParentRoute: () => AppAccountIntegrationsAppIdRoute
          })
const AppAccountIntegrationsAppIdJobsRoute = AppAccountIntegrationsAppIdJobsRouteImport.update({
            id: '/jobs',path: '/jobs',getParentRoute: () => AppAccountIntegrationsAppIdRoute
          })
const AppAccountIntegrationsAppIdPlaygroundRoute = AppAccountIntegrationsAppIdPlaygroundRouteImport.update({
            id: '/playground',path: '/playground',getParentRoute: () => AppAccountIntegrationsAppIdRoute
          })
const AppAccountIntegrationsAppIdSettingsRoute = AppAccountIntegrationsAppIdSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AppAccountIntegrationsAppIdRoute
          })
const AppDevResourcesErrorsListIndexRoute = AppDevResourcesErrorsListIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppDevResourcesErrorsListRoute
          })
const AppDevResourcesTransitionsJobsIndexRoute = AppDevResourcesTransitionsJobsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppDevResourcesTransitionsJobsRoute
          })
const AppDevResourcesTransitionsJobsJobIdRoute = AppDevResourcesTransitionsJobsJobIdRouteImport.update({
            id: '/$jobId',path: '/$jobId',getParentRoute: () => AppDevResourcesTransitionsJobsRoute
          })
const AppEmployeesListEmployeeIdReportRoute = AppEmployeesListEmployeeIdReportRouteImport.update({
            id: '/report',path: '/report',getParentRoute: () => AppEmployeesListEmployeeIdRoute
          })
const AppJobsListJobIdIndexRoute = AppJobsListJobIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppJobsListJobIdRoute
          })
const AppJobsListJobIdBoardRoute = AppJobsListJobIdBoardRouteImport.update({
            id: '/board',path: '/board',getParentRoute: () => AppJobsListJobIdRoute
          })
const AppJobsListJobIdDistributionRoute = AppJobsListJobIdDistributionRouteImport.update({
            id: '/distribution',path: '/distribution',getParentRoute: () => AppJobsListJobIdRoute
          })
const AppJobsListJobIdReportRoute = AppJobsListJobIdReportRouteImport.update({
            id: '/report',path: '/report',getParentRoute: () => AppJobsListJobIdRoute
          })
const AppOffersListOfferIdIndexRoute = AppOffersListOfferIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppOffersListOfferIdRoute
          })
const AppOffersListOfferIdBoardRoute = AppOffersListOfferIdBoardRouteImport.update({
            id: '/board',path: '/board',getParentRoute: () => AppOffersListOfferIdRoute
          })
const AppOffersListOfferIdDistributionRoute = AppOffersListOfferIdDistributionRouteImport.update({
            id: '/distribution',path: '/distribution',getParentRoute: () => AppOffersListOfferIdRoute
          })
const AppOffersListOfferIdReportRoute = AppOffersListOfferIdReportRouteImport.update({
            id: '/report',path: '/report',getParentRoute: () => AppOffersListOfferIdRoute
          })
const AppOrgsOrgIdGroupsGroupIdRoute = AppOrgsOrgIdGroupsGroupIdRouteImport.update({
            id: '/$orgId/groups/$groupId',path: '/$orgId/groups/$groupId',getParentRoute: () => AppOrgsRoute
          })
const PublicOauthAuthorizeRequestIndexRoute = PublicOauthAuthorizeRequestIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicOauthAuthorizeRequestRoute
          })
const PublicOrgsOrgIdUsersGroupsRoute = PublicOrgsOrgIdUsersGroupsRouteImport.update({
            id: '/orgs/$orgId/users/groups',path: '/orgs/$orgId/users/groups',getParentRoute: () => PublicRouteRoute
          })
const AppAccountIntegrationsAppIdApplicantsListRoute = AppAccountIntegrationsAppIdApplicantsListRouteImport.update({
            id: '/_list',getParentRoute: () => AppAccountIntegrationsAppIdApplicantsRoute
          })
const AppAccountIntegrationsAppIdCompaniesListRoute = AppAccountIntegrationsAppIdCompaniesListRouteImport.update({
            id: '/_list',getParentRoute: () => AppAccountIntegrationsAppIdCompaniesRoute
          })
const AppAccountIntegrationsAppIdJobsListRoute = AppAccountIntegrationsAppIdJobsListRouteImport.update({
            id: '/_list',getParentRoute: () => AppAccountIntegrationsAppIdJobsRoute
          })
const AppDevResourcesTransitionsJobsJobIdIndexRoute = AppDevResourcesTransitionsJobsJobIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppDevResourcesTransitionsJobsJobIdRoute
          })
const AppDevResourcesTransitionsJobsJobIdBoardRoute = AppDevResourcesTransitionsJobsJobIdBoardRouteImport.update({
            id: '/board',path: '/board',getParentRoute: () => AppDevResourcesTransitionsJobsJobIdRoute
          })
const AppDevResourcesTransitionsJobsJobIdDistributionRoute = AppDevResourcesTransitionsJobsJobIdDistributionRouteImport.update({
            id: '/distribution',path: '/distribution',getParentRoute: () => AppDevResourcesTransitionsJobsJobIdRoute
          })
const AppDevResourcesTransitionsJobsJobIdReportRoute = AppDevResourcesTransitionsJobsJobIdReportRouteImport.update({
            id: '/report',path: '/report',getParentRoute: () => AppDevResourcesTransitionsJobsJobIdRoute
          })
const AppOrgsOrgIdGroupsGroupIdIndexRoute = AppOrgsOrgIdGroupsGroupIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppOrgsOrgIdGroupsGroupIdRoute
          })
const AppOrgsOrgIdGroupsGroupIdBoardRoute = AppOrgsOrgIdGroupsGroupIdBoardRouteImport.update({
            id: '/board',path: '/board',getParentRoute: () => AppOrgsOrgIdGroupsGroupIdRoute
          })
const AppOrgsOrgIdGroupsGroupIdDistributionRoute = AppOrgsOrgIdGroupsGroupIdDistributionRouteImport.update({
            id: '/distribution',path: '/distribution',getParentRoute: () => AppOrgsOrgIdGroupsGroupIdRoute
          })
const AppOrgsOrgIdGroupsGroupIdReportRoute = AppOrgsOrgIdGroupsGroupIdReportRouteImport.update({
            id: '/report',path: '/report',getParentRoute: () => AppOrgsOrgIdGroupsGroupIdRoute
          })
const PublicOrgsOrgIdUsersGroupsIndexRoute = PublicOrgsOrgIdUsersGroupsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicOrgsOrgIdUsersGroupsRoute
          })
const AppAccountIntegrationsAppIdApplicantsListIndexRoute = AppAccountIntegrationsAppIdApplicantsListIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppAccountIntegrationsAppIdApplicantsListRoute
          })
const AppAccountIntegrationsAppIdCompaniesListIndexRoute = AppAccountIntegrationsAppIdCompaniesListIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppAccountIntegrationsAppIdCompaniesListRoute
          })
const AppAccountIntegrationsAppIdJobsListIndexRoute = AppAccountIntegrationsAppIdJobsListIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppAccountIntegrationsAppIdJobsListRoute
          })
const AppDevResourcesTransitionsJobsJobIdDistributionIndexRoute = AppDevResourcesTransitionsJobsJobIdDistributionIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppDevResourcesTransitionsJobsJobIdDistributionRoute
          })
const AppDevResourcesTransitionsJobsJobIdDistributionXRoute = AppDevResourcesTransitionsJobsJobIdDistributionXRouteImport.update({
            id: '/x',path: '/x',getParentRoute: () => AppDevResourcesTransitionsJobsJobIdDistributionRoute
          })
const AppDevResourcesTransitionsJobsJobIdDistributionYRoute = AppDevResourcesTransitionsJobsJobIdDistributionYRouteImport.update({
            id: '/y',path: '/y',getParentRoute: () => AppDevResourcesTransitionsJobsJobIdDistributionRoute
          })
const PublicOrgsOrgIdUsersGroupsGroupIdIndexRoute = PublicOrgsOrgIdUsersGroupsGroupIdIndexRouteImport.update({
            id: '/$groupId/',path: '/$groupId/',getParentRoute: () => PublicOrgsOrgIdUsersGroupsRoute
          })
const PublicOrgsOrgIdUsersGroupsGroupIdDescribeIndexRoute = PublicOrgsOrgIdUsersGroupsGroupIdDescribeIndexRouteImport.update({
            id: '/$groupId/describe/',path: '/$groupId/describe/',getParentRoute: () => PublicOrgsOrgIdUsersGroupsRoute
          })
const PublicOrgsOrgIdUsersGroupsGroupIdDescribeIndicatorStepRoute = PublicOrgsOrgIdUsersGroupsGroupIdDescribeIndicatorStepRouteImport.update({
            id: '/$groupId/describe/$indicator/$step',path: '/$groupId/describe/$indicator/$step',getParentRoute: () => PublicOrgsOrgIdUsersGroupsRoute
          })





const AtmodalRouteRouteChildren = {
  AtmodalAssistantRoute: AtmodalAssistantRoute,AtmodalCookiesRoute: AtmodalCookiesRoute,AtmodalApplicantsApplicantIdRoute: AtmodalApplicantsApplicantIdRoute,AtmodalEmployeesImportRoute: AtmodalEmployeesImportRoute,AtmodalEmployeesNewRoute: AtmodalEmployeesNewRoute,AtmodalGroupsNewRoute: AtmodalGroupsNewRoute,AtmodalJobsFindRoute: AtmodalJobsFindRoute,AtmodalJobsNewRoute: AtmodalJobsNewRoute,AtmodalMembersMemberIdRoute: AtmodalMembersMemberIdRoute,AtmodalOffersFindRoute: AtmodalOffersFindRoute,AtmodalOffersNewRoute: AtmodalOffersNewRoute,AtmodalOrgsNewRoute: AtmodalOrgsNewRoute,AtmodalSettingsAiAppsRoute: AtmodalSettingsAiAppsRoute,AtmodalSettingsLanguageRoute: AtmodalSettingsLanguageRoute,AtmodalSettingsVisibilityRoute: AtmodalSettingsVisibilityRoute,AtmodalTeamsFindRoute: AtmodalTeamsFindRoute,AtmodalTeamsNewRoute: AtmodalTeamsNewRoute,AtmodalWelcomeCompanyRoute: AtmodalWelcomeCompanyRoute,AtmodalWelcomeSamplesRoute: AtmodalWelcomeSamplesRoute,AtmodalApplicantsApplicantIdHireRoute: AtmodalApplicantsApplicantIdHireRoute,AtmodalEmployeesEmployeeIdEditRoute: AtmodalEmployeesEmployeeIdEditRoute,AtmodalGroupsGroupIdEditRoute: AtmodalGroupsGroupIdEditRoute,AtmodalJobsJobIdEditRoute: AtmodalJobsJobIdEditRoute,AtmodalOffersOfferIdEditRoute: AtmodalOffersOfferIdEditRoute,AtmodalOffersOfferIdInviteRoute: AtmodalOffersOfferIdInviteRoute,AtmodalOrgsOrgIdEditRoute: AtmodalOrgsOrgIdEditRoute,AtmodalOrgsGroupsFindRoute: AtmodalOrgsGroupsFindRoute,AtmodalTeamsTeamIdEditRoute: AtmodalTeamsTeamIdEditRoute,AtmodalJobsJobIdDescribeChar123IndicatorChar125Route: AtmodalJobsJobIdDescribeChar123IndicatorChar125Route
}

const AtmodalRouteRouteWithChildren = AtmodalRouteRoute._addFileChildren(AtmodalRouteRouteChildren)




const AppAccountApiRouteChildren = {
  AppAccountApiSplatRoute: AppAccountApiSplatRoute
}

const AppAccountApiRouteWithChildren = AppAccountApiRoute._addFileChildren(AppAccountApiRouteChildren)




const AppAccountIntegrationsAppIdApplicantsListRouteChildren = {
  AppAccountIntegrationsAppIdApplicantsListIndexRoute: AppAccountIntegrationsAppIdApplicantsListIndexRoute
}

const AppAccountIntegrationsAppIdApplicantsListRouteWithChildren = AppAccountIntegrationsAppIdApplicantsListRoute._addFileChildren(AppAccountIntegrationsAppIdApplicantsListRouteChildren)



const AppAccountIntegrationsAppIdApplicantsRouteChildren = {
  AppAccountIntegrationsAppIdApplicantsListRoute: AppAccountIntegrationsAppIdApplicantsListRouteWithChildren
}

const AppAccountIntegrationsAppIdApplicantsRouteWithChildren = AppAccountIntegrationsAppIdApplicantsRoute._addFileChildren(AppAccountIntegrationsAppIdApplicantsRouteChildren)




const AppAccountIntegrationsAppIdCompaniesListRouteChildren = {
  AppAccountIntegrationsAppIdCompaniesListIndexRoute: AppAccountIntegrationsAppIdCompaniesListIndexRoute
}

const AppAccountIntegrationsAppIdCompaniesListRouteWithChildren = AppAccountIntegrationsAppIdCompaniesListRoute._addFileChildren(AppAccountIntegrationsAppIdCompaniesListRouteChildren)



const AppAccountIntegrationsAppIdCompaniesRouteChildren = {
  AppAccountIntegrationsAppIdCompaniesListRoute: AppAccountIntegrationsAppIdCompaniesListRouteWithChildren
}

const AppAccountIntegrationsAppIdCompaniesRouteWithChildren = AppAccountIntegrationsAppIdCompaniesRoute._addFileChildren(AppAccountIntegrationsAppIdCompaniesRouteChildren)




const AppAccountIntegrationsAppIdJobsListRouteChildren = {
  AppAccountIntegrationsAppIdJobsListIndexRoute: AppAccountIntegrationsAppIdJobsListIndexRoute
}

const AppAccountIntegrationsAppIdJobsListRouteWithChildren = AppAccountIntegrationsAppIdJobsListRoute._addFileChildren(AppAccountIntegrationsAppIdJobsListRouteChildren)



const AppAccountIntegrationsAppIdJobsRouteChildren = {
  AppAccountIntegrationsAppIdJobsListRoute: AppAccountIntegrationsAppIdJobsListRouteWithChildren
}

const AppAccountIntegrationsAppIdJobsRouteWithChildren = AppAccountIntegrationsAppIdJobsRoute._addFileChildren(AppAccountIntegrationsAppIdJobsRouteChildren)



const AppAccountIntegrationsAppIdRouteChildren = {
  AppAccountIntegrationsAppIdApplicantsRoute: AppAccountIntegrationsAppIdApplicantsRouteWithChildren,AppAccountIntegrationsAppIdCompaniesRoute: AppAccountIntegrationsAppIdCompaniesRouteWithChildren,AppAccountIntegrationsAppIdJobsRoute: AppAccountIntegrationsAppIdJobsRouteWithChildren,AppAccountIntegrationsAppIdPlaygroundRoute: AppAccountIntegrationsAppIdPlaygroundRoute,AppAccountIntegrationsAppIdSettingsRoute: AppAccountIntegrationsAppIdSettingsRoute,AppAccountIntegrationsAppIdIndexRoute: AppAccountIntegrationsAppIdIndexRoute
}

const AppAccountIntegrationsAppIdRouteWithChildren = AppAccountIntegrationsAppIdRoute._addFileChildren(AppAccountIntegrationsAppIdRouteChildren)



const AppAccountIntegrationsRouteChildren = {
  AppAccountIntegrationsAppIdRoute: AppAccountIntegrationsAppIdRouteWithChildren,AppAccountIntegrationsGuideRoute: AppAccountIntegrationsGuideRoute,AppAccountIntegrationsIndexRoute: AppAccountIntegrationsIndexRoute
}

const AppAccountIntegrationsRouteWithChildren = AppAccountIntegrationsRoute._addFileChildren(AppAccountIntegrationsRouteChildren)



const AppAccountRouteChildren = {
  AppAccountApiRoute: AppAccountApiRouteWithChildren,AppAccountBillingRoute: AppAccountBillingRoute,AppAccountIntegrationsRoute: AppAccountIntegrationsRouteWithChildren,AppAccountIndexRoute: AppAccountIndexRoute
}

const AppAccountRouteWithChildren = AppAccountRoute._addFileChildren(AppAccountRouteChildren)




const AppDevResourcesErrorsListRouteChildren = {
  AppDevResourcesErrorsListIndexRoute: AppDevResourcesErrorsListIndexRoute
}

const AppDevResourcesErrorsListRouteWithChildren = AppDevResourcesErrorsListRoute._addFileChildren(AppDevResourcesErrorsListRouteChildren)



const AppDevResourcesErrorsRouteChildren = {
  AppDevResourcesErrorsListRoute: AppDevResourcesErrorsListRouteWithChildren
}

const AppDevResourcesErrorsRouteWithChildren = AppDevResourcesErrorsRoute._addFileChildren(AppDevResourcesErrorsRouteChildren)




const AppDevResourcesTransitionsJobsJobIdDistributionRouteChildren = {
  AppDevResourcesTransitionsJobsJobIdDistributionXRoute: AppDevResourcesTransitionsJobsJobIdDistributionXRoute,AppDevResourcesTransitionsJobsJobIdDistributionYRoute: AppDevResourcesTransitionsJobsJobIdDistributionYRoute,AppDevResourcesTransitionsJobsJobIdDistributionIndexRoute: AppDevResourcesTransitionsJobsJobIdDistributionIndexRoute
}

const AppDevResourcesTransitionsJobsJobIdDistributionRouteWithChildren = AppDevResourcesTransitionsJobsJobIdDistributionRoute._addFileChildren(AppDevResourcesTransitionsJobsJobIdDistributionRouteChildren)



const AppDevResourcesTransitionsJobsJobIdRouteChildren = {
  AppDevResourcesTransitionsJobsJobIdBoardRoute: AppDevResourcesTransitionsJobsJobIdBoardRoute,AppDevResourcesTransitionsJobsJobIdDistributionRoute: AppDevResourcesTransitionsJobsJobIdDistributionRouteWithChildren,AppDevResourcesTransitionsJobsJobIdReportRoute: AppDevResourcesTransitionsJobsJobIdReportRoute,AppDevResourcesTransitionsJobsJobIdIndexRoute: AppDevResourcesTransitionsJobsJobIdIndexRoute
}

const AppDevResourcesTransitionsJobsJobIdRouteWithChildren = AppDevResourcesTransitionsJobsJobIdRoute._addFileChildren(AppDevResourcesTransitionsJobsJobIdRouteChildren)



const AppDevResourcesTransitionsJobsRouteChildren = {
  AppDevResourcesTransitionsJobsJobIdRoute: AppDevResourcesTransitionsJobsJobIdRouteWithChildren,AppDevResourcesTransitionsJobsIndexRoute: AppDevResourcesTransitionsJobsIndexRoute
}

const AppDevResourcesTransitionsJobsRouteWithChildren = AppDevResourcesTransitionsJobsRoute._addFileChildren(AppDevResourcesTransitionsJobsRouteChildren)



const AppDevResourcesTransitionsRouteChildren = {
  AppDevResourcesTransitionsJobsRoute: AppDevResourcesTransitionsJobsRouteWithChildren,AppDevResourcesTransitionsStickyRoute: AppDevResourcesTransitionsStickyRoute,AppDevResourcesTransitionsTeamsRoute: AppDevResourcesTransitionsTeamsRoute,AppDevResourcesTransitionsIndexRoute: AppDevResourcesTransitionsIndexRoute
}

const AppDevResourcesTransitionsRouteWithChildren = AppDevResourcesTransitionsRoute._addFileChildren(AppDevResourcesTransitionsRouteChildren)



const AppDevResourcesRouteChildren = {
  AppDevResourcesComponentsRoute: AppDevResourcesComponentsRoute,AppDevResourcesEmailsRoute: AppDevResourcesEmailsRoute,AppDevResourcesErrorsRoute: AppDevResourcesErrorsRouteWithChildren,AppDevResourcesTransitionsRoute: AppDevResourcesTransitionsRouteWithChildren,AppDevResourcesIndexRoute: AppDevResourcesIndexRoute
}

const AppDevResourcesRouteWithChildren = AppDevResourcesRoute._addFileChildren(AppDevResourcesRouteChildren)




const AppEmployeesListEmployeeIdRouteChildren = {
  AppEmployeesListEmployeeIdReportRoute: AppEmployeesListEmployeeIdReportRoute
}

const AppEmployeesListEmployeeIdRouteWithChildren = AppEmployeesListEmployeeIdRoute._addFileChildren(AppEmployeesListEmployeeIdRouteChildren)



const AppEmployeesListRouteChildren = {
  AppEmployeesListEmployeeIdRoute: AppEmployeesListEmployeeIdRouteWithChildren,AppEmployeesListIndexRoute: AppEmployeesListIndexRoute
}

const AppEmployeesListRouteWithChildren = AppEmployeesListRoute._addFileChildren(AppEmployeesListRouteChildren)



const AppEmployeesRouteChildren = {
  AppEmployeesListRoute: AppEmployeesListRouteWithChildren
}

const AppEmployeesRouteWithChildren = AppEmployeesRoute._addFileChildren(AppEmployeesRouteChildren)




const AppJobsListJobIdRouteChildren = {
  AppJobsListJobIdBoardRoute: AppJobsListJobIdBoardRoute,AppJobsListJobIdDistributionRoute: AppJobsListJobIdDistributionRoute,AppJobsListJobIdReportRoute: AppJobsListJobIdReportRoute,AppJobsListJobIdIndexRoute: AppJobsListJobIdIndexRoute
}

const AppJobsListJobIdRouteWithChildren = AppJobsListJobIdRoute._addFileChildren(AppJobsListJobIdRouteChildren)



const AppJobsListRouteChildren = {
  AppJobsListJobIdRoute: AppJobsListJobIdRouteWithChildren,AppJobsListIndexRoute: AppJobsListIndexRoute
}

const AppJobsListRouteWithChildren = AppJobsListRoute._addFileChildren(AppJobsListRouteChildren)



const AppJobsRouteChildren = {
  AppJobsListRoute: AppJobsListRouteWithChildren
}

const AppJobsRouteWithChildren = AppJobsRoute._addFileChildren(AppJobsRouteChildren)




const AppMarketReportRouteChildren = {
  AppMarketReportIndexRoute: AppMarketReportIndexRoute
}

const AppMarketReportRouteWithChildren = AppMarketReportRoute._addFileChildren(AppMarketReportRouteChildren)



const AppMarketRouteChildren = {
  AppMarketReportRoute: AppMarketReportRouteWithChildren
}

const AppMarketRouteWithChildren = AppMarketRoute._addFileChildren(AppMarketRouteChildren)




const AppOffersListOfferIdRouteChildren = {
  AppOffersListOfferIdBoardRoute: AppOffersListOfferIdBoardRoute,AppOffersListOfferIdDistributionRoute: AppOffersListOfferIdDistributionRoute,AppOffersListOfferIdReportRoute: AppOffersListOfferIdReportRoute,AppOffersListOfferIdIndexRoute: AppOffersListOfferIdIndexRoute
}

const AppOffersListOfferIdRouteWithChildren = AppOffersListOfferIdRoute._addFileChildren(AppOffersListOfferIdRouteChildren)



const AppOffersListRouteChildren = {
  AppOffersListOfferIdRoute: AppOffersListOfferIdRouteWithChildren,AppOffersListIndexRoute: AppOffersListIndexRoute
}

const AppOffersListRouteWithChildren = AppOffersListRoute._addFileChildren(AppOffersListRouteChildren)



const AppOffersRouteChildren = {
  AppOffersListRoute: AppOffersListRouteWithChildren
}

const AppOffersRouteWithChildren = AppOffersRoute._addFileChildren(AppOffersRouteChildren)




const AppOrgsOrgIdGroupsGroupIdRouteChildren = {
  AppOrgsOrgIdGroupsGroupIdBoardRoute: AppOrgsOrgIdGroupsGroupIdBoardRoute,AppOrgsOrgIdGroupsGroupIdDistributionRoute: AppOrgsOrgIdGroupsGroupIdDistributionRoute,AppOrgsOrgIdGroupsGroupIdReportRoute: AppOrgsOrgIdGroupsGroupIdReportRoute,AppOrgsOrgIdGroupsGroupIdIndexRoute: AppOrgsOrgIdGroupsGroupIdIndexRoute
}

const AppOrgsOrgIdGroupsGroupIdRouteWithChildren = AppOrgsOrgIdGroupsGroupIdRoute._addFileChildren(AppOrgsOrgIdGroupsGroupIdRouteChildren)



const AppOrgsRouteChildren = {
  AppOrgsIndexRoute: AppOrgsIndexRoute,AppOrgsOrgIdIndexRoute: AppOrgsOrgIdIndexRoute,AppOrgsOrgIdGroupsGroupIdRoute: AppOrgsOrgIdGroupsGroupIdRouteWithChildren
}

const AppOrgsRouteWithChildren = AppOrgsRoute._addFileChildren(AppOrgsRouteChildren)




const AppReportReportRouteChildren = {
  AppReportReportIndexRoute: AppReportReportIndexRoute
}

const AppReportReportRouteWithChildren = AppReportReportRoute._addFileChildren(AppReportReportRouteChildren)



const AppReportRouteChildren = {
  AppReportReportRoute: AppReportReportRouteWithChildren
}

const AppReportRouteWithChildren = AppReportRoute._addFileChildren(AppReportRouteChildren)




const AppTeamsTeamIdRouteChildren = {
  AppTeamsTeamIdBoardRoute: AppTeamsTeamIdBoardRoute,AppTeamsTeamIdDistributionRoute: AppTeamsTeamIdDistributionRoute,AppTeamsTeamIdEvaluateRoute: AppTeamsTeamIdEvaluateRoute,AppTeamsTeamIdEvaluationRoute: AppTeamsTeamIdEvaluationRoute,AppTeamsTeamIdReportRoute: AppTeamsTeamIdReportRoute,AppTeamsTeamIdIndexRoute: AppTeamsTeamIdIndexRoute
}

const AppTeamsTeamIdRouteWithChildren = AppTeamsTeamIdRoute._addFileChildren(AppTeamsTeamIdRouteChildren)



const AppTeamsRouteChildren = {
  AppTeamsTeamIdRoute: AppTeamsTeamIdRouteWithChildren,AppTeamsIndexRoute: AppTeamsIndexRoute
}

const AppTeamsRouteWithChildren = AppTeamsRoute._addFileChildren(AppTeamsRouteChildren)



const AppRouteRouteChildren = {
  AppAccountRoute: AppAccountRouteWithChildren,AppCheckoutRoute: AppCheckoutRoute,AppDevResourcesRoute: AppDevResourcesRouteWithChildren,AppEmployeesRoute: AppEmployeesRouteWithChildren,AppJobsRoute: AppJobsRouteWithChildren,AppMarketRoute: AppMarketRouteWithChildren,AppOffersRoute: AppOffersRouteWithChildren,AppOrgsRoute: AppOrgsRouteWithChildren,AppReportRoute: AppReportRouteWithChildren,AppTeamsRoute: AppTeamsRouteWithChildren,AppBetaGenerateRoute: AppBetaGenerateRoute,AppTestCompetencesRoute: AppTestCompetencesRoute,AppTestPersonalityRoute: AppTestPersonalityRoute,AppTestValuesRoute: AppTestValuesRoute,AppTestIndexRoute: AppTestIndexRoute
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(AppRouteRouteChildren)




const LandingRouteRouteChildren = {
  LandingCookiesPolicyRoute: LandingCookiesPolicyRoute,LandingDocsRoute: LandingDocsRoute,LandingPrivacyPolicyRoute: LandingPrivacyPolicyRoute,LandingTermsOfUseRoute: LandingTermsOfUseRoute
}

const LandingRouteRouteWithChildren = LandingRouteRoute._addFileChildren(LandingRouteRouteChildren)




const PublicOauthAuthorizeRequestRouteChildren = {
  PublicOauthAuthorizeRequestIndexRoute: PublicOauthAuthorizeRequestIndexRoute
}

const PublicOauthAuthorizeRequestRouteWithChildren = PublicOauthAuthorizeRequestRoute._addFileChildren(PublicOauthAuthorizeRequestRouteChildren)



const PublicOauthAuthorizeRouteChildren = {
  PublicOauthAuthorizeRequestRoute: PublicOauthAuthorizeRequestRouteWithChildren
}

const PublicOauthAuthorizeRouteWithChildren = PublicOauthAuthorizeRoute._addFileChildren(PublicOauthAuthorizeRouteChildren)




const PublicOrgsOrgIdUsersGroupsRouteChildren = {
  PublicOrgsOrgIdUsersGroupsIndexRoute: PublicOrgsOrgIdUsersGroupsIndexRoute,PublicOrgsOrgIdUsersGroupsGroupIdIndexRoute: PublicOrgsOrgIdUsersGroupsGroupIdIndexRoute,PublicOrgsOrgIdUsersGroupsGroupIdDescribeIndexRoute: PublicOrgsOrgIdUsersGroupsGroupIdDescribeIndexRoute,PublicOrgsOrgIdUsersGroupsGroupIdDescribeIndicatorStepRoute: PublicOrgsOrgIdUsersGroupsGroupIdDescribeIndicatorStepRoute
}

const PublicOrgsOrgIdUsersGroupsRouteWithChildren = PublicOrgsOrgIdUsersGroupsRoute._addFileChildren(PublicOrgsOrgIdUsersGroupsRouteChildren)



const PublicRouteRouteChildren = {
  PublicBeginPasswordResetRoute: PublicBeginPasswordResetRoute,PublicLoginRoute: PublicLoginRoute,PublicEmployeeInvitationTokenRoute: PublicEmployeeInvitationTokenRoute,PublicOauthAuthorizeRoute: PublicOauthAuthorizeRouteWithChildren,PublicRegisterApplicantRoute: PublicRegisterApplicantRoute,PublicRegisterCompanyRoute: PublicRegisterCompanyRoute,PublicUpdatePasswordTokenRoute: PublicUpdatePasswordTokenRoute,PublicVerifyEmailTokenRoute: PublicVerifyEmailTokenRoute,PublicRegisterIndexRoute: PublicRegisterIndexRoute,PublicOrgsOrgIdUsersGroupsRoute: PublicOrgsOrgIdUsersGroupsRouteWithChildren
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(PublicRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AtmodalRouteRoute: AtmodalRouteRouteWithChildren,AppRouteRoute: AppRouteRouteWithChildren,LandingRouteRoute: LandingRouteRouteWithChildren,PublicRouteRoute: PublicRouteRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)